import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.error) {
      const { error } = this.state;
      return (
        <div style={{
          minHeight: '100vh', padding: 32,
          background: '#0A0A0A', color: '#F5F5F5',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <h1 style={{ color: '#FF5050', marginBottom: 16 }}>
            Erro no app
          </h1>
          <p style={{ marginBottom: 12 }}>
            Algo quebrou na renderização. Manda este texto pra quem está te ajudando:
          </p>
          <pre style={{
            background: '#1C1C1C', padding: 16, borderRadius: 8,
            overflow: 'auto', fontSize: 12, lineHeight: 1.5,
            border: '1px solid #383838',
          }}>
{String(error?.name || 'Error')}: {String(error?.message || error)}
{'\n\n'}
{String(error?.stack || '(no stack)')}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 20, padding: '10px 18px', fontSize: 14,
              background: '#00CC44', color: '#0A0A0A', border: 'none',
              borderRadius: 8, cursor: 'pointer', fontWeight: 700,
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
